/*
 * @prop --component-tooltip-color-content-text: The color the tooltip content text
 * @prop --component-tooltip-color-content-background: The color the tooltip content background
 * @prop --component-tooltip-color-content-box-shadow: The color the tooltip content box shadow
 * @prop --component-tooltip-color-trigger: The color the tooltip trigger
 * @prop --component-tooltip-z-index: z-index parent component passed
*/

:host {
  --tooltip-open-duration: 0.2s;

  display: inline-block;

  .tooltip {
    @extend %caption;

    max-width: 280px;
    z-index: var(--component-tooltip-z-index, $z-index-tooltip);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    white-space: normal;
    position: absolute;
    top: 0;
    left: 0;

    &[data-placement^='top'] {
      > .tooltip__arrow {
        margin-top: -1px;
        top: 100%;

        &::before {
          transform: rotate(180deg);
        }
      }
    }

    &[data-placement^='bottom'] {
      > .tooltip__arrow {
        bottom: 100%;
      }
    }

    &__content {
      position: relative;
      padding: 14px 16px 15px;
      color: var(
        --component-tooltip-color-content-text,
        var(--skin-color-white, $ui-white)
      );
      background-color: var(
        --component-tooltip-color-content-background,
        var(--skin-color-primary, $ui-blue)
      );
      z-index: var(--component-tooltip-z-index, $z-index-tooltip);
      box-shadow: 0 2px 3px
        var(
          --component-tooltip-color-content-box-shadow,
          var(--skin-color-primary-shade, $ui-blue-plus-2)
        );
    }

    &__arrow,
    &__arrow::before {
      position: absolute;
      border-style: solid;
      border-width: 0 10px 16px;
      border-color: transparent transparent
        var(
          --component-tooltip-color-content-background,
          var(--skin-color-primary, $ui-blue)
        )
        transparent;
      z-index: calc(var(--component-tooltip-z-index, $z-index-tooltip) - 1);
      margin-top: 1px;
      filter: drop-shadow(
        0 2px 3px
          var(
            --component-tooltip-color-content-box-shadow,
            var(--skin-color-primary-shade, $ui-blue-plus-2)
          )
      );
    }

    &__arrow {
      visibility: hidden;
      width: 20px;

      &::before {
        height: 100%;
        visibility: hidden;
        opacity: 0;
        content: '';
      }
    }

    &[data-show] {
      visibility: visible;
      opacity: 1;
      pointer-events: all;
      transition:
        opacity var(--tooltip-open-duration, 0.2),
        visibility var(--tooltip-open-duration, 0.2);
      z-index: var(--component-tooltip-z-index, $z-index-tooltip);

      .tooltip__arrow {
        &::before {
          opacity: 1;
          visibility: visible;
          transition:
            opacity var(--tooltip-open-duration, 0.2),
            visibility var(--tooltip-open-duration, 0.2);
        }
      }
    }

    @include breakpoint($smallMaxWidth) {
      width: calc(100vw - 86px);
      max-width: inherit;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .ui-icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
    pointer-events: none;

    &.active {
      @include icon-color(
        var(
          --component-tooltip-color-trigger,
          var(--skin-color-accent, $ui-green)
        )
      );
    }
  }

  .trigger {
    cursor: pointer;

    &.active * {
      color: var(
        --component-tooltip-color-trigger,
        var(--skin-color-accent, $ui-green)
      );
    }
  }
}

:host(.inherit-style) {
  .tooltip {
    max-width: inherit;
  }
}

:host(.large) .ui-icon {
  width: 24px;
  height: 24px;
}
